import {yearSection} from '~/utils/function';

/**
 * 判断是移动端还是PC端
 * 如果为true则是移动端，为false就是PC端
 */

export const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);

/**
 * 处理移动端搜索框的数据
 */
export const yearSelect = [];
yearSelect.push(yearSection());

// 生成分页数组
export const pageSection = function (total, pageNum) {
    let startPage = 1;
    const endPage = Math.ceil(total / pageNum);
    const section = endPage - startPage;
    const pageArr = [];
    for (let i = 0; i <= section; i++) {
        const ep = startPage++;
        pageArr.push({label: ep, value: ep});
    }
    return pageArr;
};

